module.exports = __webpack_public_path__ + "static/media/8F19B759-235D-41EB-8783-08608EF6CCA7.030838f9.jpeg";